const internalSymB2B = Symbol.for('stytch__internal_b2b');
const internalSymB2C = Symbol.for('stytch__internal_b2c');
const writeB2BInternals = (obj, internals)=>{
    Object.assign(obj, {
        [internalSymB2B]: internals
    });
};
const readB2BInternals = (obj)=>{
    const casted = obj;
    if (!casted[internalSymB2B]) {
        throw Error('Internals not found!');
    }
    return casted[internalSymB2B];
};
const writeB2CInternals = (obj, internals)=>{
    Object.assign(obj, {
        [internalSymB2C]: internals
    });
};
const readB2CInternals = (obj)=>{
    const casted = obj;
    if (!casted[internalSymB2C]) {
        throw Error('Internals not found!');
    }
    return casted[internalSymB2C];
};

export { internalSymB2B, internalSymB2C, readB2BInternals, readB2CInternals, writeB2BInternals, writeB2CInternals };
//# sourceMappingURL=internal.mjs.map
